import { useEffect, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import api from 'helpers/api'
import CircleOk from "components/assets/icons/CircleOk"

const Unpaid = () => {
  const { t } = useTranslation()
  const { lang, token, adhesionId } = useOutletContext()
  const messageSent = useRef(false)

  useEffect(() => {
    const sendMessage = async () => {
      try {
        messageSent.current = true
        await api.post({
          url: `/clients/revival/contact`,
          data: {
            subject: "Paiement d’un impayé",
            text: "Message automatique venant du mail de relance d’un impayé",
            adhesionId
          },
          headers: { Authorization: `Bearer ${token}` }
        })
      } catch (error) {
        console.log('error sending message')
      }
    }
    if (messageSent.current === false) sendMessage()
  }, [messageSent, token, adhesionId])


  return(
    <>
      <h1>
        {t(`contract:revival.unpaid.${lang}.title`)}
        <CircleOk />
      </h1>
      <p>{t(`contract:revival.unpaid.${lang}.text`)}</p>
    </>
  )
}

export default Unpaid